import React from "react";
import { Card, Table, Badge } from "react-bootstrap";
import { Zap, MessageSquare } from "lucide-react";

const PartnerPlansTable = ({ currentPartner }) => {
  const whatsappTotal = currentPartner?.partnerWhatsappMessageLimit;
  const whatsappRemaining = currentPartner?.partnerRemainingWhatsappMessageLimit;
  const whatsappConsumed =
    whatsappTotal !== undefined &&
      whatsappTotal !== null &&
      whatsappRemaining !== undefined &&
      whatsappRemaining !== null
      ? whatsappTotal - whatsappRemaining
      : undefined;

  return (
    <Card className="premium-card qx-section-card qx-table-card mb-4">
      <Card.Body>
        <div className="d-flex align-items-center justify-content-between px-3 pt-3 pb-2 flex-wrap gap-2">
          <h6 className="qx-section-card__title text-uppercase small mb-0">
            Plans & Limits
          </h6>
        </div>

        <Table responsive className="mb-0 align-middle">
          <thead>
            <tr>
              <th><strong>Plan </strong></th>
              <th><strong>Total Allotted</strong></th>
              <th><strong>Consumed</strong></th>
              <th><strong>Remaining</strong></th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(currentPartner?.partnerPlans) && currentPartner.partnerPlans.length > 0 ? (
              currentPartner.partnerPlans.map((plan, idx) => {
                const planName = plan?.subscriptionId?.name || plan?.name || "—";
                const total = plan.totalHostLimit ?? plan.hostLimit ?? 0;
                const remaining = plan.remainingHostLimit ?? 0;
                const consumed = Math.max(0, total - remaining);

                return (
                  <tr key={plan._id || plan.id || idx}>
                    <td className="fw-semibold text-capitalize">
                      <Zap size={16} className="me-2" style={{ color: "#A60000" }} />
                      {planName}
                    </td>
                    <td>{total} Wedding</td>
                    <td>{consumed} Wedding</td>
                    <td>{remaining} Wedding</td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={4} className="text-muted text-center py-3">
                  No plans assigned
                </td>
              </tr>
            )}

            {whatsappTotal !== undefined && whatsappTotal !== null && (
              <tr>
                <td className="fw-semibold">
                  <MessageSquare size={16} className="me-2" style={{ color: "#A60000" }} /> WhatsApp Message Limit
                </td>
                <td>
                  {Number(whatsappTotal).toLocaleString("en-IN")}
                </td>
                <td>
                  {whatsappConsumed !== undefined && whatsappConsumed !== null
                    ? Number(whatsappConsumed).toLocaleString("en-IN")
                    : "—"}
                </td>
                <td>
                  {whatsappRemaining !== undefined && whatsappRemaining !== null
                    ? Number(whatsappRemaining).toLocaleString("en-IN")
                    : "—"}
                </td>
              </tr>
            )}

            {currentPartner?.spentAmount !== undefined && currentPartner?.spentAmount !== null && (
              <tr style={{ backgroundColor: "#fcfcfd", borderTop: "2px solid #e2e8f0" }}>
                <td className="fw-bold" colSpan={3}>
                  <Badge

                    className="px-3 py-2 fw-semibold text-white"
                    style={{ borderRadius: "0.5rem", backgroundColor: "#A60100" }}
                  >
                    Actual Amount
                  </Badge>
                </td>
                <td className="fw-bold" style={{ fontSize: "1.05rem", color: "#A60100" }}>
                  ₹{Number(currentPartner.spentAmount || 0).toLocaleString("en-IN")}
                </td>
              </tr>
            )}

            {currentPartner?.receiverAmount !== undefined && currentPartner?.receiverAmount !== null && (
              <tr style={{ backgroundColor: "#fcfcfd" }}>
                <td className="fw-bold" colSpan={3}>
                  <Badge
                    bg="success"
                    className="px-3 py-2 fw-semibold text-white"
                    style={{ borderRadius: "0.5rem", backgroundColor: "#2BC155" }}
                  >
                    Received Amount
                  </Badge>
                </td>
                <td className="fw-bold text-success" style={{ fontSize: "1.05rem" }}>
                  ₹{Number(currentPartner.receiverAmount || 0).toLocaleString("en-IN")}
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};

export default PartnerPlansTable;
